import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
} from "react-bootstrap";

import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "./config";
import AdminHeader from "./AdminHeader";
import { encryptValue } from "./utils/crypto";

function SampleData() {
  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState("jan");
  const [loading, setLoading] = useState(false);

  const months = [
    { label: "January", value: "jan" },
    { label: "February", value: "feb" },
    { label: "March", value: "mar" },
    { label: "April", value: "apr" },
    { label: "May", value: "may" },
    { label: "June", value: "jun" },
    { label: "July", value: "jul" },
    { label: "August", value: "aug" },
    { label: "September", value: "sep" },
    { label: "October", value: "oct" },
    { label: "November", value: "nov" },
    { label: "December", value: "dec" },
  ];

  // Months having 30 generated records (1-30)
  const months30 = [
    "jan",
    "mar",
    "may",
    "jul",
    "aug",
    "oct",
    "dec",
  ];

  // Months having 29 generated records (1-29)
  const months29 = [
    "apr",
    "jun",
    "sep",
    "nov",
    "feb",
  ];

  const getDays = () => {
    if (months30.includes(month)) return 30;
    if (months29.includes(month)) return 29;
    return 30;
  };

  const generateRandom = () => {
    return Math.floor(Math.random() * 99 + 1)
      .toString()
      .padStart(2, "0");
  };

  const handleGenerate = async () => {
    try {
      setLoading(true);

      const docRef = doc(db, "chart_data", year.toString());

      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        const data = snapshot.data();

        if (data?.[month]) {
          const password = prompt(
            `${month.toUpperCase()} ${year} already has data.\n\nEnter Override Password`
          );

          if (password !== "123456") {
            alert("Invalid Password");
            setLoading(false);
            return;
          }
        }
      }

      const totalDays = getDays();

      const monthData = {};

      for (let i = 1; i <= totalDays; i++) {
        const number = generateRandom();

        monthData[i] = {
          number: encryptValue(number),
          time: serverTimestamp(),
        };
      }

      if (!snapshot.exists()) {
        await setDoc(docRef, {
          [month]: monthData,
        });
      } else {
        await updateDoc(docRef, {
          [month]: monthData,
        });
      }

      alert(
        `${months.find((m) => m.value === month)?.label
        } ${year} sample data generated successfully.`
      );
    } catch (err) {
      console.log(err);
      alert("Something went wrong.");
    }

    setLoading(false);
  };

  return (
    <>
      <AdminHeader />

      <Container className="py-5">

        <Row className="justify-content-center">

          <Col lg={6}>

            <Card className="shadow border-0">

              <Card.Body>

                <h3 className="mb-2">
                  Generate Sample Data
                </h3>

                <p className="text-muted mb-4">
                  Generate complete monthly chart data with one click.
                </p>

                <Form.Group className="mb-3">
                  <Form.Label>Year</Form.Label>

                  <Form.Control
                    type="number"
                    value={year}
                    onChange={(e) =>
                      setYear(e.target.value)
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Month</Form.Label>

                  <Form.Select
                    value={month}
                    onChange={(e) =>
                      setMonth(e.target.value)
                    }
                  >
                    {months.map((item) => (
                      <option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <div className="mb-4">

                  <strong>
                    Records to Generate :
                  </strong>{" "}
                  {getDays()}

                  <br />

                  <small className="text-muted">
                    Random numbers between 00 - 99
                  </small>

                </div>

                <Button
                  variant="dark"
                  size="lg"
                  disabled={loading}
                  onClick={handleGenerate}
                >
                  {loading
                    ? "Generating..."
                    : "Generate Sample Data"}
                </Button>

              </Card.Body>

            </Card>

          </Col>

        </Row>

      </Container>
    </>
  );
}

export default SampleData;